import { Component, OnInit, inject } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet, ActivatedRoute } from '@angular/router';
import { AdminSidebar } from '../../components/admin-dashboard-component/admin-sidebar/admin-sidebar';
import { PageHeader } from '../../components/admin-dashboard-component/page-header/page-header';
import { AdminHeader } from '../../components/admin-dashboard-component/header/header';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-admin-dashboard',
  imports: [RouterOutlet, AdminSidebar, PageHeader, AdminHeader],
  templateUrl: './admin-dashboard.html',
  styleUrl: './admin-dashboard.scss',
})
export class AdminDashboard implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  isSidebarCollapsed = false;
  currentPageTitle = 'Dashboard';
  currentPageUrl = '/admin';
  breadcrumbs: { label: string; url: string }[] = [];

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.updateBreadcrumbs();
    });
    setTimeout(() => this.updateBreadcrumbs());
  }

  private updateBreadcrumbs() {
    let route = this.activatedRoute.root;
    let url = '';
    const breadcrumbs: Array<{ label: string; url: string }> = [];
    while (route.children.length > 0) {
      route = route.children[0];
      const routeConfig = route.snapshot.routeConfig;
      if (!routeConfig) continue;
      if (routeConfig.path) {
        url += `/${routeConfig.path}`;
        const params = route.snapshot.params;
        Object.keys(params).forEach((key) => {
          url = url.replace(`:${key}`, params[key]);
        });
      }
      if (route.snapshot.data['breadcrumb']) {
        breadcrumbs.push({
          label: route.snapshot.data['breadcrumb'],
          url: url,
        });
      }
    }
    const dedupedBreadcrumbs: Array<{ label: string; url: string }> = [];
    breadcrumbs.forEach((crumb, index) => {
      if (index == 0 || crumb.label != breadcrumbs[index - 1].label) {
        dedupedBreadcrumbs.push(crumb);
      }
    });
    if (dedupedBreadcrumbs.length > 0) {
      const lastBreadcrumb = dedupedBreadcrumbs[dedupedBreadcrumbs.length - 1];
      this.currentPageTitle = lastBreadcrumb.label;
      this.currentPageUrl = lastBreadcrumb.url;
      this.breadcrumbs = dedupedBreadcrumbs.slice(0, -1);
    } else {
      this.currentPageTitle = 'Dashboard';
      this.currentPageUrl = '/admin';
      this.breadcrumbs = [];
    }
    if (this.currentPageUrl == '/admin' || this.currentPageUrl == '') {
      this.breadcrumbs = [];
    }
  }

  onSidebarToggle() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
}
